import { render, staticRenderFns } from "./ContratCreate.vue?vue&type=template&id=5ad38b6f&"
import script from "./ContratCreate.vue?vue&type=script&lang=js&"
export * from "./ContratCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports